import {
    Breadcrumbs as SparkyBreadcrumbs,
    BreadcrumbsItem as SparkyBreadcrumbsItem,
} from '@petsmart-ui/sparky';
import { JsonLd } from '@libs/common-next';
import BreadcrumbsAdjuster from './BreadcrumbsAdjuster';

import type { BreadcrumbsProps, BreadcrumbsItem } from './types';

import './Breadcrumbs.scss';

export default function Breadcrumbs({
    containerSelector,
    items,
    seo,
    isLastItemVisible = true,
    ...props
}: BreadcrumbsProps) {
    return (
        <>
            <SparkyBreadcrumbs {...props}>
                <>
                    {items.map((item: BreadcrumbsItem) => (
                        <SparkyBreadcrumbsItem {...item} key={item.key} />
                    ))}
                    {!isLastItemVisible && (
                        <SparkyBreadcrumbsItem className="breadcrumbs__item--hidden" />
                    )}
                </>
            </SparkyBreadcrumbs>
            {containerSelector && (
                <BreadcrumbsAdjuster
                    containerSelector={containerSelector}
                    isLastItemVisible={isLastItemVisible}
                />
            )}

            {seo && <JsonLd {...seo} />}
        </>
    );
}
